<template>
  <div class="relative">
    <input
      :type="type"
      :disabled="disabled"
      :class="[inputWidthHeightClass, borderClass, errorClass, customInputStyle , truncateClass]"
      v-model="vModel"
      :id="`i_${id}`"
      :name="id"
      class="main-input"
      @input="onInputChange"
      @blur="$emit('getApiToken')"
      :readonly="readOnly"
      ref="baseInput"
    />
    <span class="highlight" />
    <label :for="`i_${id}`" class="ease-input" v-if="inputType === 'ease'">
      <slot name="text" />
    </label>
    <label :for="`i_${id}`" class="simple-input" v-if="inputType === 'simple'">
      <slot name="text" />
    </label>
    <div class="error-messages" v-if="!this.isValid">
      <slot name="errorMessage" />
    </div>
    <div class="input-icon">
      <slot name="icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  data() {
    return {
      isPhoneInvalid: false,
    };
  },
  props: {
    truncate: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    fieldType: {
      type: String,
      default: '',
      required: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    id: {
      type: String,
      required: true,
    },
    inputType: {
      type: String,
      default: 'simple',
    },
    inputValue: {
      type: [String, Number],
      default: '',
    },
    width: {
      type: String,
      default: '250',
    },
    height: {
      type: String,
      default: '68',
    },
    radius: {
      type: String,
      default: 'sm',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    customStyle: {
      type: String,
      default: '',
    },
    shouldFocus: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.shouldFocus) {
      this.$refs.baseInput.focus();
    }
  },
  computed: {
    vModel: {
      get() {
        return this.inputValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    customInputStyle() {
      return this.customStyle ? this.customStyle : 'input';
    },
    borderClass() {
      return {
        rounded: this.radius === 'default',
        'rounded-sm': this.radius === 'sm',
        'rounded-t-sm': this.radius === 't-sm',
        'rounded-b-sm': this.radius === 'b-sm',
      };
    },
    inputWidthHeightClass() {
      return `w-${this.width} h-${this.height}`;
    },
    truncateClass() {
      return this.truncate ? 'truncate' : '';
    },
    errorClass() {
      return this.isValid ? 'border-default' : 'border border-danger';
    },
  },
  methods: {
    onInputChange(event) {
      this.$emit('change', event.target.value, this.fieldType);
      this.isPhoneInvalid = event.target.value.length <= 2;
      this.$emit('isPhoneValid', this.isPhoneInvalid);
    },
  },
};
</script>

<style scoped>
.input {
  @apply block py-10 text-12 text-title relative font-semibold outline-none
    focus:outline-none disabled:text-disabled
    focus:ring-0;
}
.label-ease {
  @apply text-18 font-normal absolute px-5 py-5 mx-5 text-title
    transition-all ease-in-out duration-300;
  top: 0.3rem;
}
.label-simple {
  @apply text-12 font-semibold absolute px-5 py-5 mx-5 text-title;
  top: 0.7rem;
}
.error-messages {
  @apply inline-block text-12 mt-5 mb-0 mx-0 text-danger;
}
input::placeholder {
  @apply opacity-0;
}
input:focus ~ label.input-type-ease,
input:not(:placeholder-shown) ~ label.input-type-ease {
  @apply -top-15 text-12 text-title;
}
input ~ label.input-type-ease {
  @apply font-normal;
}
input:focus ~ label.input-type-simple,
input:not(:placeholder-shown) ~ label.input-type-simple {
  @apply hidden;
}
.main-input {
  @apply border border-default focus:border-active bg-secondary placeholder-subtitle
   outline-none;
}
.ease-input {
  @apply label-ease input-type-ease bg-secondary cursor-text text-title;
}
.simple-input {
  @apply label-simple input-type-simple bg-secondary;
}
.input-icon {
  @apply absolute right-0 top-1/4;
}
.input-icon:is(:lang(fa), :lang(ar)) {
  @apply absolute right-auto top-1/4 left-0;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
